import { render, staticRenderFns } from "./TrsBudgetDetail.vue?vue&type=template&id=e73d558e&scoped=true"
import script from "./TrsBudgetDetail.vue?vue&type=script&lang=js"
export * from "./TrsBudgetDetail.vue?vue&type=script&lang=js"
import style0 from "./TrsBudgetDetail.vue?vue&type=style&index=0&id=e73d558e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73d558e",
  null
  
)

export default component.exports